// IAM role names from internal/authz/principal.go. A "normal user" holds
// neither role and sees only the self-service (/me) area.
export type RoleName = "super_admin" | "tenant_admin";

export interface Persona {
  isOperator: boolean;
  isTenantAdmin: boolean;
  isUser: boolean;
}

export function personaFromRoles(roles: readonly string[]): Persona {
  return {
    isOperator: roles.includes("super_admin"),
    isTenantAdmin: roles.includes("tenant_admin"),
    isUser: true,
  };
}

export function knownRoles(roles: readonly string[]): RoleName[] {
  return roles.filter((role): role is RoleName => role === "super_admin" || role === "tenant_admin");
}
